import { AxiosResponse } from "axios";
import axiosInstance from "../../../interceptors/axiosInstance";
import { ListResponseDto } from "../../../dtos/ListResponseDto";
import { Banco } from "../hooks/useSubsidioMutuo";


const getSubsidioMutuo = async (mutuoId: number) => {
    const response: AxiosResponse = await axiosInstance.get(`siscred-api-mutuo/v1/subsidio-mutuo/${mutuoId}/subsidio`);
    return response;
};

const getBancos = async () => {
    const response: AxiosResponse<ListResponseDto<Banco>> = await axiosInstance.get('siscred-api-transversal/v1/instituciones/obtener-datos-banco');
    return response;
};
export { getSubsidioMutuo, getBancos }